/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressWrite } from './addressWrite';
import { TeacherRegistrationKindergarten } from './teacherRegistrationKindergarten';

export interface TeacherRegistrationOrganization { 
    /**
     * IČO
     */
    lawId?: string;
    /**
     * RED_IZO = Resortní identifikátor právnické osoby vykonávající činnost školy
     */
    redIzo?: string;
    /**
     * Oficiální název organizace
     */
    officialName: string;
    address: AddressWrite;
    kindergartens: Array<TeacherRegistrationKindergarten>;
}